import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Spacer from '@helsenorge/designsystem-react/components/Spacer';
import Title from '@helsenorge/designsystem-react/components/Title';
const TjenesterGroup = props => {
    return (_jsxs("div", { children: [props.title && (_jsxs(_Fragment, { children: [_jsx(Title, { htmlMarkup: 'h2', appearance: 'title2', children: props.title }), _jsx(Spacer, { size: "s" })] })), props.children] }));
};
export default TjenesterGroup;
